import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import "./CountIcon.scss";
import { Col, Row } from "reactstrap";

/**
 * CountIcon.
 */
const CountIcon = ({ icon, color, count, onClick, ...other }) => {
  const cls = ["count-icon-container"];

  if (onClick) {
    cls.push("link");
  }

  return (
    <Row className={classNames(cls)} onClick={onClick} {...other}>
      <Col md={12} xs={true} className="icon">
        <FontAwesomeIcon
          icon={icon}
          style={{
            color: color,
          }}
        />
      </Col>
      <Col md={12} xs={true}>
        <div className="count">{count}</div>
      </Col>
    </Row>
  );
};

CountIcon.defaultProps = {
  color: "#4f4f4f",
};
CountIcon.propTypes = {
  icon: PropTypes.object.isRequired,
  color: PropTypes.string,
  count: PropTypes.number.isRequired,
};
export default CountIcon;
